<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M20.4896 3.51134C15.8081 -1.17058 8.19144 -1.17058 3.51088 3.51021C-1.17059 8.191 -1.17014 15.8079 3.51133 20.4896C8.19144 25.1702 15.8081 25.1702 20.4891 20.4887C25.1701 15.8079 25.1699 8.19145 20.4896 3.51134ZM19.1796 19.1796C15.2209 23.1383 8.77934 23.1388 4.82041 19.1801C0.860804 15.2207 0.861256 8.77845 4.82041 4.81974C8.77911 0.861267 15.2204 0.860815 19.18 4.8202C23.1387 8.7789 23.1383 15.2211 19.1796 19.1796ZM17.4281 16.7454C17.577 17.0896 17.4186 17.489 17.0746 17.6377C16.7305 17.787 16.3311 17.6282 16.1822 17.2842C15.5275 15.7706 13.9804 14.7923 12.24 14.7923C10.4595 14.7923 8.90289 15.7696 8.27494 17.2824C8.16655 17.5435 7.91378 17.7013 7.64789 17.7013C7.561 17.7013 7.47297 17.6845 7.38766 17.6492C7.04144 17.5053 6.87738 17.1079 7.02107 16.7619C7.86061 14.7407 9.90943 13.4348 12.24 13.4348C14.5219 13.4348 16.5585 14.7341 17.4281 16.7454ZM7.52185 8.75061C7.52185 7.9758 8.15026 7.34739 8.92507 7.34739C9.69966 7.34739 10.3281 7.97557 10.3281 8.75061C10.3281 9.52588 9.69966 10.1541 8.92507 10.1541C8.15026 10.1541 7.52185 9.52588 7.52185 8.75061ZM13.8844 8.75061C13.8844 7.9758 14.5133 7.34739 15.2881 7.34739C16.0627 7.34739 16.6911 7.97557 16.6911 8.75061C16.6911 9.52588 16.0629 10.1541 15.2881 10.1541C14.5133 10.1541 13.8844 9.52588 13.8844 8.75061Z" fill="#FD85A2"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
name: "IconFaceSad"
}
</script>

<style scoped>

</style>